import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Checkbox } from "antd";
import { ButtonProps, getWalletDays } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import { FiPlusCircle } from "react-icons/fi";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillButton from "../Items/Button/Index";
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));
// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));

const OfferDiscountOnInvoiceModalComponent: React.FC<
  CollectOpenEndUserInvoicePaymentProp
> = ({ show, handleClose, invoice }) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<OfferDiscountAmountOnInvoiceApiProp>(
    "endUsers/discountAmountOnInvoice",
    true
  );

  const onFinish = (values: any) => {
    const { amount } = values;

    const dataToSend: OfferDiscountAmountOnInvoiceApiProp = {
      invoiceDiscountAmount: Number(amount),
      intPkEndUserID: invoice.intPkEndUserID,
      intPkEndUserInvoiceID: invoice.intPkEndUserInvoiceID,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <MeshBillModal
        title="Offer Discount On Invoice"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="invoiceDiscountAmountForm"
              initialValues={{
                amount: invoice.invoiceRemainingAmount,
              }}
              form={form}
            >
              <Form.Item
                name="amount"
                rules={[
                  { required: true, message: "Please Enter Amount" },
                  {
                    validator: (_, value) =>
                      value > -1
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Amount must be greater than 0")
                          ),
                  },
                  {
                    validator: (_, value) =>
                      value > invoice.invoiceRemainingAmount
                        ? Promise.reject(
                            new Error(
                              "Amount must not be greater than Remaining Amount"
                            )
                          )
                        : Promise.resolve(),
                  },
                ]}
                label={
                  <span className="create-user-form-label">
                    Discount Amount
                  </span>
                }
              >
                <Input
                  type="number"
                  className="user-input-general-height"
                  placeholder="10"
                />
              </Form.Item>

              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Submit"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default OfferDiscountOnInvoiceModalComponent;
